<template>
  <v-navigation-drawer
    v-model="localShowNavigation"
    width="330"
    app
    :permanent="$vuetify.breakpoint.mdAndUp"
    :expand-on-hover="!localShowNavigation && $vuetify.breakpoint.mdAndUp"
  >
    <navigation-header />
    <v-list nav>
      <v-auth :authorized-roles="[roles.ROLE_STREAM_MANAGER]">
        <navigation-group :group-name="$t('STREAMING')" group-icon="live_tv">
          <navigation-item :title="$t('CONTROL')" route="/streams/control" />
          <v-auth :authorized-roles="[roles.ROLE_ROOT]">
            <navigation-item :title="$t('SETTINGS')" route="/streams/config" />
          </v-auth>
        </navigation-group>
      </v-auth>
      <v-auth :authorized-roles="[roles.ROLE_VOD_MANAGER]">
        <navigation-group :group-name="$t('VOD')" group-icon="movie">
          <navigation-item :title="$t('BROWSE_VIDEOS')" route="/vod/browse-videos" />
          <navigation-item
            :title="$t('VIDEO_PUBLICATIONS_LIST')"
            route="/vod/video-publications-list/"
            :params="{ page: 1 }"
          />
        </navigation-group>
      </v-auth>
      <v-auth :authorized-roles="[roles.ROLE_DOCUMENT_MANAGER, roles.ROLE_DOCUMENT_VIEWER]">
        <navigation-group :group-name="$t('DOCUMENTS')" group-icon="library_books">
          <v-auth :authorized-roles="[roles.ROLE_DOCUMENT_MANAGER]">
            <navigation-item :title="$t('CREATE_DOCUMENT')" route="/documents/create" />
          </v-auth>
          <v-auth :authorized-roles="[roles.ROLE_DOCUMENT_MANAGER, roles.ROLE_DOCUMENT_VIEWER]">
            <navigation-item
              :title="$t('DOCUMENTS_LIST')"
              route="/documents/list/"
              :params="{ page: 1 }"
            />
          </v-auth>
        </navigation-group>
      </v-auth>
      <v-auth :authorized-roles="[roles.ROLE_NOTIFICATION_MANAGER]">
        <navigation-group :group-name="$t('NOTIFICATIONS')" group-icon="chat">
          <v-auth :authorized-roles="[roles.ROLE_NOTIFICATION_MANAGER]">
            <navigation-item
              :title="$t('NOTIFICATIONS_LIST')"
              route="/users/notifications-list/"
              :params="{ page: 1 }"
            />
            <navigation-item :title="$t('NOTIFICATIONS_SEND')" route="/users/notifications-send" />
          </v-auth>
        </navigation-group>
      </v-auth>
      <v-auth v-if="$vuetify.breakpoint.mdAndDown" :authorized-roles="[roles.ROLE_USER_MANAGER]">
        <navigation-group :group-name="$t('USERS')" group-icon="account_circle">
          <navigation-item :title="$t('USERS_LIST')" route="/users/list/" :params="{ page: 1 }" />
        </navigation-group>
      </v-auth>
      <v-auth v-if="$vuetify.breakpoint.mdAndDown" :authorized-roles="[roles.ROLE_GROUP_MANAGER]">
        <navigation-group :group-name="$t('USERS_GROUPS')" group-icon="group">
          <navigation-item :title="$t('GROUPS_LIST')" route="/groups/list/" :params="{ page: 1 }" />
        </navigation-group>
      </v-auth>
      <v-auth :authorized-roles="[roles.ROLE_VOTE_MANAGER]">
        <navigation-group :group-name="$t('SESSIONS')" group-icon="smart_display">
          <v-auth :authorized-roles="[roles.ROLE_VOTE_MANAGER]">
            <navigation-item
              :title="$t('SESSIONS_LIST')"
              route="/sessions/list/"
              :params="{ page: 1 }"
            />
          </v-auth>
          <v-auth :authorized-roles="[roles.ROLE_VOTE_MANAGER]">
            <navigation-item
              :title="$t('SESSIONS_CREATE')"
              route="/sessions/create/"
            />
          </v-auth>
          <v-auth :authorized-roles="[roles.ROLE_VOTE_MANAGER]">
            <navigation-item
              :title="$t('PARTICIPANTS_LIST')"
              route="/sessions/participants/"
              :params="{ page: 1 }"
            />
          </v-auth>
          <v-auth :authorized-roles="[roles.ROLE_VOTE_MANAGER]">
            <navigation-item
              :title="$t('GO_TO_PROJECTOR')"
              :inNewCard="true"
              route="/voter/projector"
            />
          </v-auth>
        </navigation-group>
      </v-auth>
      <v-auth :authorized-roles="[roles.ROLE_VOTE_VIEWER]">
        <navigation-group :group-name="$t('VOTE')" group-icon="how_to_vote">
          <v-auth :authorized-roles="[roles.ROLE_VOTE_VIEWER]">
            <navigation-item
              :title="$t('CURRENT_VOTE')"
              route="/vote/active/"
            />
          </v-auth>
        </navigation-group>
      </v-auth>
      <v-auth :authorized-roles="[roles.ROLE_CMS_MANAGER]">
        <navigation-group :group-name="$t('PAGES')" group-icon="create">
          <v-auth :authorized-roles="[roles.ROLE_CMS_MANAGER]">
            <navigation-item
              :title="$t('PAGES_LIST')"
              route="/pages/list/"
              :params="{ page: 1 }"
            />
          </v-auth>
          <v-auth :authorized-roles="[roles.ROLE_CMS_MANAGER]">
            <navigation-item
              :title="$t('CREATE_PAGE')"
              route="/pages/create/"
            />
          </v-auth>
          <v-auth :authorized-roles="[roles.ROLE_CMS_MANAGER]">
            <navigation-item
              :title="$t('MENU')"
              route="/pages/menu/"
              :params="{ page: 1 }"
            />
          </v-auth>
        </navigation-group>
      </v-auth>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
  import NavigationItem from './TheNavItem';
  import NavigationHeader from './TheNavHeader';
  import NavigationGroup from './TheNavGroup';
  import VAuth from '../../__base/VAuth';

  import * as roles from '../../../utils/user-roles';

  export default {
    name: 'TheNavigation',
    components: {
      VAuth,
      NavigationGroup,
      NavigationHeader,
      NavigationItem,
    },
    props: {
      showNavigation: Boolean,
    },
    data() {
      return {
        localShowNavigation: true,
        roles,
      };
    },
    watch: {
      showNavigation: {
        handler(newVal) {
          this.localShowNavigation = newVal;
        },
        immediate: true,
      },

      localShowNavigation(newVal) {
        if (newVal !== this.showNavigation) {
          this.$emit('toggle-navigation');
        }
      },
    },
  };
</script>

<style lang="scss">
  .v-application--is-ltr .v-list-item__action:last-of-type:not(:only-child),
  .v-application--is-ltr .v-list-item__avatar:last-of-type:not(:only-child),
  .v-application--is-ltr .v-list-item__icon:last-of-type:not(:only-child) {
    margin-left: 0;
  }

  .v-application--is-ltr .v-list-item__action:first-child,
  .v-application--is-ltr .v-list-item__icon:first-child {
    margin-right: 25px;
  }
</style>
